<template>
    <div class="slideshow">
        <div
            v-for="image in images"
            :key="image"
            class="callout-image" :class="{active: imageActive(image)}" :style="backgroundStyle(image)" />
    </div>
</template>

<script>
export default {
    name: "Slideshow",
    props: {
        images: {
            type: Array,
            required: true
        },
    },
    data() {
        return {activeIndex: 0};
    },
    mounted() {
        const vm = this;
        vm._interval = setInterval(() => { vm.next() }, 8000)
    },
    unmounted() {
        const vm = this;
        clearInterval(vm._interval);
    },
    computed: {
        nextIndex() {
            const vm = this;
            if (vm.activeIndex >= vm.images.length - 1) {
                return 0;
            } else {
                return vm.activeIndex + 1;
            }
        },
        prevIndex() {
            const vm = this;
            if (vm.activeIndex <= 0) {
                return vm.images.length - 1;
            } else {
                return vm.activeIndex - 1;
            }
        },
    },
    methods: {
        next() {
            const vm = this;
            vm.activeIndex = vm.nextIndex
        },
        imageActive(image) {
            const vm = this;
            return vm.images.indexOf(image) === vm.activeIndex;
        },
        backgroundStyle(image) {
            const vm = this
            const i = vm.images.indexOf(image)
            const show = [vm.activeIndex, vm.nextIndex, vm.prevIndex].includes(i)

            if (show) return `background-image: url(${image})`
        },
    }
};

</script>

<style lang="scss">
</style>
